import React, { FunctionComponent, useState } from "react";
import styles from "./css/Section5.module.css";
import phone from "../../assets/mariana_pics/onePlus.png";
import { FormControl, MenuItem, Select, TextField } from "@mui/material";
import sendEmail from "../../emailutil";
import { useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import sendEmailToOwner from "../../emailUtilOwner";

const Section5 = () => {
  const [name, setName] = useState("");
  const [socialLink, setSocialLink] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [country, setCountry] = useState("");
  const [telephone, setTelephone] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");

  const reduxStateLanguage = useSelector((state: any) => state.language.value);

  const handleSubject = (event: SelectChangeEvent) => {
    setSubject(event.target.value);
  };

  const handleSendEmail = () => {
    // Check if all required fields are filled
    if (
      !name ||
      !socialLink ||
      !dateOfBirth ||
      !country ||
      !telephone ||
      !email ||
      !subject ||
      !message
    ) {
      notify(false);
      return;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast(
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            width: "100%",
          }}
        >
          {reduxStateLanguage === "EN"
            ? "Please enter a valid email address"
            : "Vă rugăm să introduceți o adresă de email validă"}
        </div>,
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        }
      );
      return;
    }

    const emailData = {
      userEmail: email,
      itemName: "Consultation Request",
      subject: "New Consultation Request",
      message: `Name: ${name}<br>Email: ${email}<br>Date of Birth: ${dateOfBirth}<br>Telephone: ${telephone}<br>Country: ${country}<br>Social link: ${socialLink}<br>Phone: ${telephone}<br>Subject: ${subject} <br>Message: ${message}`,
      name: name,
    };

    const emailDataForUser = {
      userEmail: email,
      itemName: "Consultation Request",
      subject: "New Consultation Request",
      message: `You have booked a free consultation with Spirit Liber. We will contact you as soon as possible.`,
      name: name,
      recepient: email,
    };

    sendEmail(emailDataForUser);
    sendEmailToOwner(emailData);
    setName("");
    setSocialLink("");
    setDateOfBirth("");
    setCountry("");
    setTelephone("");
    setEmail("");
    setSubject("");
    setMessage("");
    notify(true);
  };

  const notify = (successful: boolean) => {
    toast(
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          width: "100%",
        }}
      >
        {successful
          ? reduxStateLanguage === "EN"
            ? "Email sent successfully"
            : reduxStateLanguage === "RO"
            ? "Email-ul a fost trimis cu succes"
            : ""
          : reduxStateLanguage === "EN"
          ? "Email sending failed"
          : reduxStateLanguage === "RO"
          ? "Trimiterea email-ului a eșuat"
          : ""}
      </div>,
      {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      }
    );
  };

  return (
    <div
      className={styles.frag}
      style={{ backgroundColor: "#F9F6E9" }}
      id="section8"
    >
      <ToastContainer />
      <div className={styles.mainContainer}>
        <div className={styles.header}>
          <div className={styles.conversationForm}>
            <span className={styles.programConversation}>
              {reduxStateLanguage === "EN" &&
                "To schedule a conversation with Spirit Liber, please "}
              {reduxStateLanguage === "RO" &&
                "Pentru a programa o conversație cu Spirit Liber, te rog să "}
            </span>
            <span className={styles.completeFields}>
              {reduxStateLanguage === "EN" && "fill in the fields below:"}
              {reduxStateLanguage === "RO" &&
                "completezi câmpurile de mai jos:"}
            </span>
          </div>
          <span className={styles.programConversationFields}>
            {reduxStateLanguage === "EN"
              ? "To schedule a conversation with Spirit Liber, please fill in the fields below:"
              : "Pentru a programa o conversație cu Spirit Liber, te rog să completezi câmpurile de mai jos:"}
          </span>
        </div>

        <div className={styles.formContainer}>
          <div className={styles.form}>
            <div className={styles.formC}>
              <div className={styles.frame}>
                <div className={styles.frameD}>
                  <TextField
                    sx={{
                      width: "100%",
                      height: "inherit",
                      "& .MuiFilledInput-root": {
                        backgroundColor: "transparent",
                        height: "inherit",
                        borderBottom: "0",
                        "&::placeholder": {
                          color: "#517059",
                          opacity: 1,
                          fontFamily: "Lora",
                        },
                      },
                      "&.css-1pht7va-MuiInputBase-root-MuiFilledInput-root::after ":
                        {
                          content: "none",
                          display: "none",
                          border: "unset",
                        },
                      input: {
                        color: "#517059",
                        fontFamily: "Lora",
                      },
                      "& .MuiInputBase-input::placeholder": {
                        color: "#517059",
                        opacity: 1,
                        fontFamily: "Lora",
                      },
                    }}
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    hiddenLabel
                    id="filled-hidden-label-normal"
                    placeholder={
                      reduxStateLanguage === "EN"
                        ? "Your name *"
                        : reduxStateLanguage === "RO"
                        ? "Numele tău *"
                        : ""
                    }
                    variant="filled"
                  />
                </div>
                <div className={styles.frameD}>
                  <TextField
                    sx={{
                      width: "100%",

                      height: "auto",
                      "& .MuiFilledInput-root": {
                        backgroundColor: "transparent",
                        height: "inherit",
                        borderBottom: "0",
                      },
                      "&.MuiInputBase-root-MuiFilledInput-root::after": {
                        content: "none",
                        display: "none",
                        borderBottom: "unset",
                      },
                      "& .MuiInputBase-root-MuiFilledInput-root::before ": {
                        content: "none",
                        display: "none",
                        border: "unset",
                      },
                      "& .MuiInputBase-root-MuiFilledInput-root:hover": {
                        backgroundColor: "transparent",
                        borderBottom: "none",
                      },
                      input: {
                        color: "#517059",
                        fontFamily: "Lora",
                      },
                      "& .MuiInputBase-input::placeholder": {
                        color: "#517059",
                        opacity: 1,
                        fontFamily: "Lora",
                      },
                      "& .MuiFilledInput-root": {
                        color: "#517059",
                        "&::placeholder": {
                          color: "#517059",
                          opacity: 1,
                          fontFamily: "Lora",
                        },
                      },
                    }}
                    hiddenLabel
                    value={socialLink}
                    onChange={(e) => setSocialLink(e.target.value)}
                    id="filled-hidden-label-normal"
                    placeholder={
                      reduxStateLanguage === "EN"
                        ? "Link to your social media *"
                        : reduxStateLanguage === "RO"
                        ? "Link-ul la retelele sociale *"
                        : ""
                    }
                    variant="filled"
                  />
                </div>
              </div>
              <div className={styles.frameF}>
                <div className={styles.frame10}>
                  <TextField
                    sx={{
                      width: "100%",
                      height: "auto",
                      "& .MuiFilledInput-root": {
                        backgroundColor: "transparent",
                        height: "inherit",
                        borderBottom: "0",
                      },
                      "&.MuiInputBase-root-MuiFilledInput-root::after": {
                        content: "none",
                        display: "none",
                        borderBottom: "unset",
                      },
                      "& .MuiInputBase-root-MuiFilledInput-root::before ": {
                        content: "none",
                        display: "none",
                        border: "unset",
                      },
                      "& .MuiInputBase-root-MuiFilledInput-root:hover": {
                        backgroundColor: "transparent",
                        borderBottom: "none",
                      },
                      input: {
                        color: "#517059",
                        fontFamily: "Lora",
                      },
                      "& .MuiInputBase-input::placeholder": {
                        color: "#517059",
                        opacity: 1,
                        fontFamily: "Lora",
                      },
                      "& .MuiFilledInput-root": {
                        color: "#517059",
                        "&::placeholder": {
                          color: "#517059",
                          opacity: 1,
                          fontFamily: "Lora",
                        },
                      },
                    }}
                    hiddenLabel
                    onChange={(e) => setDateOfBirth(e.target.value)}
                    value={dateOfBirth}
                    id="filled-hidden-label-normal"
                    placeholder={
                      reduxStateLanguage === "EN"
                        ? "Date / Month / Year of birth *"
                        : reduxStateLanguage === "RO"
                        ? "Data / Luna / Anul nasterii *"
                        : ""
                    }
                    variant="filled"
                  />
                </div>
                <div className={styles.frame11}>
                  <TextField
                    sx={{
                      width: "100%",
                      height: "auto",
                      "& .MuiFilledInput-root": {
                        backgroundColor: "transparent",
                        height: "inherit",
                        borderBottom: "0",
                      },
                      "&.MuiInputBase-root-MuiFilledInput-root::after": {
                        content: "none",
                        display: "none",
                        borderBottom: "unset",
                      },
                      "& .MuiInputBase-root-MuiFilledInput-root::before ": {
                        content: "none",
                        display: "none",
                        border: "unset",
                      },
                      "& .MuiInputBase-root-MuiFilledInput-root:hover": {
                        backgroundColor: "transparent",
                        borderBottom: "none",
                      },
                      input: {
                        color: "#517059",
                        fontFamily: "Lora",
                      },
                      "& .MuiInputBase-input::placeholder": {
                        color: "#517059",
                        opacity: 1,
                        fontFamily: "Lora",
                      },
                      "& .MuiFilledInput-root": {
                        color: "#517059",
                        "&::placeholder": {
                          color: "#517059",
                          opacity: 1,
                          fontFamily: "Lora",
                        },
                      },
                    }}
                    hiddenLabel
                    onChange={(e) => setCountry(e.target.value)}
                    value={country}
                    id="filled-hidden-label-normal"
                    placeholder={
                      reduxStateLanguage === "EN"
                        ? "Country of residence *"
                        : reduxStateLanguage === "RO"
                        ? "Tara de rezindenta *"
                        : ""
                    }
                    variant="filled"
                  />
                </div>
              </div>
              <div className={styles.frame12}>
                <div className={styles.frame13}>
                  <TextField
                    sx={{
                      width: "100%",
                      height: "auto",
                      "& .MuiFilledInput-root": {
                        backgroundColor: "transparent",
                        height: "inherit",
                        borderBottom: "0",
                      },
                      "&.MuiInputBase-root-MuiFilledInput-root::after": {
                        content: "none",
                        display: "none",
                        borderBottom: "unset",
                      },
                      "& .MuiInputBase-root-MuiFilledInput-root::before ": {
                        content: "none",
                        display: "none",
                        border: "unset",
                      },
                      "& .MuiInputBase-root-MuiFilledInput-root:hover": {
                        backgroundColor: "transparent",
                        borderBottom: "none",
                      },
                      input: {
                        color: "#517059",
                        fontFamily: "Lora",
                      },
                      "& .MuiInputBase-input::placeholder": {
                        color: "#517059",
                        opacity: 1,
                        fontFamily: "Lora",
                      },
                      "& .MuiFilledInput-root": {
                        color: "#517059",
                        "&::placeholder": {
                          color: "#517059",
                          opacity: 1,
                          fontFamily: "Lora",
                        },
                      },
                    }}
                    hiddenLabel
                    onChange={(e) => setTelephone(e.target.value)}
                    value={telephone}
                    id="filled-hidden-label-normal"
                    placeholder={
                      reduxStateLanguage === "EN"
                        ? "Phone number *"
                        : reduxStateLanguage === "RO"
                        ? "Numar de telefon *"
                        : ""
                    }
                    variant="filled"
                  />
                </div>
                <div className={styles.frame16}>
                  <TextField
                    sx={{
                      width: "100%",
                      height: "auto",
                      "& .MuiFilledInput-root": {
                        backgroundColor: "transparent",
                        height: "inherit",
                        borderBottom: "0",
                      },
                      "&.MuiInputBase-root-MuiFilledInput-root::after": {
                        content: "none",
                        display: "none",
                        borderBottom: "unset",
                      },
                      "& .MuiInputBase-root-MuiFilledInput-root::before ": {
                        content: "none",
                        display: "none",
                        border: "unset",
                      },
                      "& .MuiInputBase-root-MuiFilledInput-root:hover": {
                        backgroundColor: "transparent",
                        borderBottom: "none",
                      },
                      input: {
                        color: "#517059",
                        fontFamily: "Lora",
                      },
                      "& .MuiInputBase-input::placeholder": {
                        color: "#517059",
                        opacity: 1,
                        fontFamily: "Lora",
                      },
                      "& .MuiFilledInput-root": {
                        color: "#517059",
                        "&::placeholder": {
                          color: "#517059",
                          opacity: 1,
                          fontFamily: "Lora",
                        },
                      },
                    }}
                    hiddenLabel
                    onChange={(e) => setEmail(e.target.value)}
                    value={email}
                    id="filled-hidden-label-normal"
                    placeholder={
                      reduxStateLanguage === "EN"
                        ? "E-mail *"
                        : reduxStateLanguage === "RO"
                        ? "E-mail *"
                        : ""
                    }
                    variant="filled"
                  />
                </div>
              </div>
              <div className={styles.frame18}>
                <div className={styles.frame19}>
                  <FormControl className={styles.formControl2}>
                    <Select
                      sx={{
                        border: "none",
                        borderRadius: "0",
                        color: "#517059",
                        fontFamily: "Lora",
                        ".MuiSelect-select": {
                          color: "#517059",
                          fontFamily: "Lora",
                        },
                        "& .MuiSelect-icon": {
                          color: "#517059",
                        },
                        "& .MuiSelect-outlined": {
                          color: "#517059",
                        },
                        "& .MuiInputBase-input": {
                          color: "#517059",
                          fontFamily: "Lora",
                        },
                        "& .MuiSelect-select:not([multiple]) option": {
                          color: "#517059",
                          fontFamily: "Lora",
                        },
                        "& .MuiSelect-select em": {
                          color: "#517059",
                          fontStyle: "inherit",
                          fontFamily: "Lora",
                        },
                      }}
                      value={subject}
                      onChange={handleSubject}
                      displayEmpty
                      renderValue={(selected) => {
                        if (!selected) {
                          return (
                            <em
                              style={{
                                color: "#517059",
                                fontStyle: "inherit",
                                fontFamily: "Lora",
                              }}
                            >
                              {reduxStateLanguage === "EN"
                                ? "Select subject"
                                : "Selectează subiectul"}
                            </em>
                          );
                        }
                        return selected;
                      }}
                    >
                      <MenuItem
                        value={
                          reduxStateLanguage === "RO" ? "Tema 1" : "Subject 1"
                        }
                        sx={{ color: "#517059", fontFamily: "Lora" }}
                      >
                        {reduxStateLanguage === "RO" ? "Tema 1" : "Subject 1"}
                      </MenuItem>
                      <MenuItem
                        value={
                          reduxStateLanguage === "RO" ? "Tema 2" : "Subject 2"
                        }
                        sx={{ color: "#517059", fontFamily: "Lora" }}
                      >
                        {reduxStateLanguage === "RO" ? "Tema 2" : "Subject 2"}
                      </MenuItem>
                      <MenuItem
                        value={
                          reduxStateLanguage === "RO" ? "Tema 3" : "Subject 3"
                        }
                        sx={{ color: "#517059", fontFamily: "Lora" }}
                      >
                        {reduxStateLanguage === "RO" ? "Tema 3" : "Subject 3"}
                      </MenuItem>
                    </Select>
                  </FormControl>
                </div>
              </div>
              <div className={styles.frame1a}>
                <TextField
                  sx={{
                    width: "100%",
                    height: "inherit",
                    "& .MuiFilledInput-root": {
                      backgroundColor: "transparent",
                      height: "auto",
                      borderBottom: "0",
                    },
                    "&.MuiInputBase-root-MuiFilledInput-root::after": {
                      content: "none",
                      display: "none",
                      borderBottom: "unset",
                    },
                    "& .MuiInputBase-root-MuiFilledInput-root::before ": {
                      content: "none",
                      display: "none",
                      border: "unset",
                    },
                    "& .MuiInputBase-root-MuiFilledInput-root:hover": {
                      backgroundColor: "transparent",
                      borderBottom: "none",
                    },
                    "& .MuiFilledInput-input": {
                      height: "auto !important",
                      resize: "vertical",
                      minHeight: "100px",
                    },
                    input: {
                      color: "#517059",
                      fontFamily: "Lora",
                    },
                    "& .MuiInputBase-input::placeholder": {
                      color: "#517059",
                      opacity: 1,
                      fontFamily: "Lora",
                    },
                    "& .MuiFilledInput-root": {
                      color: "#517059",
                      "&::placeholder": {
                        color: "#517059",
                        opacity: 1,
                        fontFamily: "Lora",
                      },
                    },
                  }}
                  hiddenLabel
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  id="filled-hidden-label-normal"
                  placeholder={
                    reduxStateLanguage === "EN"
                      ? "What would you like to discuss in 60 minutes? *"
                      : reduxStateLanguage === "RO"
                      ? "Ce doriti sa discutam in decurs de 60 minute? *"
                      : ""
                  }
                  variant="filled"
                  multiline
                  minRows={3}
                  maxRows={10}
                />
              </div>
            </div>
            <div className={styles.frame1c}>
              <button className={styles.button} onClick={handleSendEmail}>
                <span className={styles.sendRequest}>
                  {reduxStateLanguage == "EN" && "Send request"}
                  {reduxStateLanguage == "RO" && "Trimite cerere"}
                </span>
              </button>
              <span className={styles.contactYouAfterForm}>
                {/* * После заполнения формы я свяжусь с вами для уточнения времени */}
                {reduxStateLanguage == "EN" &&
                  "* After filling the form, I will contact you to clarify the time"}
                {reduxStateLanguage == "RO" &&
                  "* Dupa completarea formularului, va voi contacta pentru clarificarea timpului"}
              </span>
            </div>
          </div>
          <div className={styles.oneplusPro}>
            <img src={phone} className={styles.phone1} alt="phone" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section5;
